export default __webpack_public_path__ + "static/media/CHL-Logo.081a55c0.jpg";